import React from 'react';
import { useTranslation } from 'react-i18next';
import './MaxCommandsInput.scss';
import { Option } from '../../../common/interfaces';
import { Dropdown } from '../../FormComponents/Dropdown/Dropdown';
import useProject from '../../../hooks/useProject';

const MaxCommandsInput = () => {
  const { t } = useTranslation();
  const { updateEncoder, updateStream, project } = useProject();
  const debounce = 500;
  const options: Option[] = [];

  options.push({ text: `1 command`, value: '1' });

  for (let i = 2; i <= 60; i++) {
    options.push({ text: `${i} commands`, value: i.toString() });
  }

  const onChange = (option: Option) => {
    if (project.encoder) {
      if (project.stream.sourceLanguageIsoCode === project.encoder.languageIsoCode) {
        updateStream({
          aggregatorMaxCommands: parseInt(option.value),
        }, debounce);
      } else {
        updateEncoder(project.encoder, {
          aggregatorMaxCommands: parseInt(option.value),
        }, debounce);
      }
    }
  };

  return (
    <div className="max-commands-input">
      <div className="input-title">{t('producer.inputs.max-commands.title')}</div>
      <Dropdown
        value={project.encoder.aggregatorMaxCommands.toString()}
        options={options}
        onChange={onChange}
        placeholderKey="producer.inputs.max-commands.placeholder"
        readonly={false}
      />
      <div className="input-component-footer">{t('producer.inputs.max-commands.footer')}</div>
    </div>
  );
};

export default React.memo(MaxCommandsInput);
